import './TextArea.css'

export default function TextArea(props) {

    var outline = props.outline || '1px';
    console.log(outline)
    return (
        <div style = {{width: props.width, maxWidth: props.maxWidth || "", boxSizing: "border-box"}}>
            <textarea id = {props.inputId} className = "text-area" placeholder = {props.placeholder} style = {{width: "100%", maxWidth: "100%", borderWidth: outline, fontSize: '16px'}}></textarea>
        </div>
    )
}